import { useParams, Link } from 'react-router-dom';
import { articles } from '../../../mocks/articles';
import { useEffect } from 'react';

export default function ArticleDetailPage() {
  const { id } = useParams();
  const article = articles.find((a) => a.id === id);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  if (!article) {
    return (
      <div className="min-h-screen bg-white flex items-center justify-center">
        <div className="text-center">
          <h1 className="text-4xl font-bold text-[#1A2B4A] mb-4">Article non trouvé</h1>
          <Link to="/articles" className="text-[#C9A961] hover:underline">
            Retour aux articles
          </Link>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-white">
      {/* Navigation */}
      <nav className="bg-white shadow-md sticky top-0 z-50">
        <div className="px-20 py-6">
          <div className="flex items-center justify-between">
            <Link to="/" className="flex items-center">
              <img 
                src="https://static.readdy.ai/image/2b97dc596bbe8fcb59c5903c7da9385e/8fbf45a2724c466b60f81eb478c19778.jpeg" 
                alt="ATMA Consulting" 
                className="h-20 w-auto object-contain"
              />
            </Link>
            
            <div className="flex items-center gap-8">
              <Link to="/management-leadership" className="text-gray-700 hover:text-[#C9A961] transition-colors duration-300 text-base font-medium whitespace-nowrap">
                Management &amp; Leadership
              </Link>
              <Link to="/strategie-operationnelle" className="text-gray-700 hover:text-[#C9A961] transition-colors duration-300 text-base font-medium whitespace-nowrap">
                Stratégie Opérationnelle
              </Link>
              <Link to="/suivi-productivite" className="text-gray-700 hover:text-[#C9A961] transition-colors duration-300 text-base font-medium whitespace-nowrap">
                Suivi &amp; Productivité
              </Link>
              <Link to="/rh-developpement" className="text-gray-700 hover:text-[#C9A961] transition-colors duration-300 text-base font-medium whitespace-nowrap">
                RH &amp; Développement
              </Link>
              <Link to="/articles" className="text-[#C9A961] font-semibold transition-colors duration-300 text-base whitespace-nowrap">
                Articles
              </Link>
            </div>

            <a href="mailto:michiele.tornabene@atmahealthcareconsulting.com" className="bg-[#1A2B4A] text-white px-8 py-3 rounded-full font-semibold hover:bg-[#C9A961] transition-all duration-300 whitespace-nowrap cursor-pointer">
              Écrire un E-mail
            </a>
          </div>
        </div>
      </nav>

      {/* Hero Section */}
      <section className="relative h-[600px] flex items-center justify-center overflow-hidden">
        <div className="absolute inset-0">
          <img 
            src={article.image}
            alt={article.title}
            className="w-full h-full object-cover object-top"
          />
          <div className="absolute inset-0 bg-gradient-to-b from-[#1A2B4A]/80 via-[#1A2B4A]/70 to-[#1A2B4A]/80"></div>
        </div>

        <div className="relative z-10 px-20 text-center w-full max-w-5xl">
          <div className="text-sm text-white/70 mb-6">
            <Link to="/" className="hover:text-white transition-colors duration-300">Accueil</Link>
            <span className="mx-3">&gt;</span>
            <Link to="/articles" className="hover:text-white transition-colors duration-300">Articles</Link>
            <span className="mx-3">&gt;</span>
            <span>{article.title}</span>
          </div>
          <div className="inline-block bg-[#C9A961] text-white px-6 py-2 rounded-full text-sm font-semibold mb-6">
            {article.category}
          </div>
          <h1 className="text-5xl font-bold text-white mb-8 leading-tight">
            {article.title}
          </h1>
          <div className="flex items-center justify-center gap-8 text-white/80">
            <span className="flex items-center gap-2">
              <i className="ri-calendar-line"></i>
              {new Date(article.date).toLocaleDateString('fr-FR', {
                day: 'numeric',
                month: 'long',
                year: 'numeric'
              })}
            </span>
            <span className="flex items-center gap-2">
              <i className="ri-time-line"></i>
              {article.readTime}
            </span>
            <span className="flex items-center gap-2">
              <i className="ri-user-line"></i>
              {article.author}
            </span>
          </div>
        </div>
      </section>

      {/* Article Content */}
      <section className="py-20 px-20">
        <div className="max-w-4xl mx-auto">
          <div 
            className="article-content prose prose-lg max-w-none"
            dangerouslySetInnerHTML={{ __html: article.content }}
          />

          {/* Share Section */}
          <div className="mt-16 pt-8 border-t border-gray-200">
            <div className="flex items-center justify-between">
              <div>
                <h3 className="text-xl font-bold text-[#1A2B4A] mb-2">Retrouvez-nous sur LinkedIn</h3>
                <div className="flex gap-4">
                  <a 
                    href="https://www.linkedin.com/company/atma-healthcare-consulting-1/posts/?feedView=all"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="w-12 h-12 bg-[#1A2B4A] text-white rounded-full flex items-center justify-center hover:bg-[#C9A961] transition-colors duration-300 cursor-pointer"
                  >
                    <i className="ri-linkedin-fill text-xl"></i>
                  </a>
                </div>
              </div>
              <Link 
                to="/articles"
                className="bg-[#1A2B4A] text-white px-8 py-3 rounded-full font-semibold hover:bg-[#C9A961] transition-all duration-300 whitespace-nowrap cursor-pointer"
              >
                Retour aux articles
              </Link>
            </div>
          </div>
        </div>
      </section>

      {/* Newsletter CTA */}
      <section className="py-24 px-20 bg-gradient-to-r from-[#1A2B4A] to-[#2A3B5A]">
        <div className="max-w-4xl mx-auto text-center">
          <h2 className="text-4xl font-bold text-white mb-6">
            Restez Informé
          </h2>
          <p className="text-xl text-white/80 mb-10">
            Écrivez-nous pour en parler
          </p>
          <div className="flex items-center justify-center gap-4">
            <a
              href="mailto:michiele.tornabene@atmahealthcareconsulting.com"
              className="inline-block bg-gradient-to-r from-[#C9A961] to-[#B8935A] text-white px-10 py-4 rounded-full text-lg font-semibold hover:shadow-2xl hover:scale-105 transition-all duration-300 whitespace-nowrap cursor-pointer"
            >
              Écrire un E-mail
            </a>
          </div>
        </div>
      </section>

      {/* Footer */}
      <footer className="bg-[#0F1A2E] text-white py-20 px-20">
        <div className="max-w-7xl mx-auto">
          <div className="grid grid-cols-4 gap-12 mb-16">
            <div>
              <img 
                src="https://static.readdy.ai/image/2b97dc596bbe8fcb59c5903c7da9385e/8fbf45a2724c466b60f81eb478c19778.jpeg" 
                alt="ATMA Consulting" 
                className="h-16 w-auto object-contain mb-6"
              />
              <p className="text-gray-400 mb-6 leading-relaxed">
                Excellence opérationnelle et humaine
              </p>
              <div className="flex gap-4">
                <a href="https://www.linkedin.com/company/atma-healthcare-consulting-1/posts/?feedView=all" target="_blank" rel="noopener noreferrer" className="w-10 h-10 bg-white/10 rounded-full flex items-center justify-center hover:bg-[#C9A961] transition-colors duration-300 cursor-pointer">
                  <i className="ri-linkedin-fill text-xl"></i>
                </a>
              </div>
            </div>

            <div>
              <h4 className="text-sm uppercase text-gray-400 mb-6 font-semibold">Nos Services</h4>
              <ul className="space-y-3">
                <li>
                  <Link to="/management-leadership" className="text-white hover:text-[#C9A961] transition-colors duration-300">
                    Management &amp; Leadership
                  </Link>
                </li>
                <li>
                  <Link to="/strategie-operationnelle" className="text-white hover:text-[#C9A961] transition-colors duration-300">
                    Stratégie Opérationnelle
                  </Link>
                </li>
                <li>
                  <Link to="/suivi-productivite" className="text-white hover:text-[#C9A961] transition-colors duration-300">
                    Suivi &amp; Productivité
                  </Link>
                </li>
                <li>
                  <Link to="/rh-developpement" className="text-white hover:text-[#C9A961] transition-colors duration-300">
                    RH &amp; Développement
                  </Link>
                </li>
              </ul>
            </div>

            <div>
              <h4 className="text-sm uppercase text-gray-400 mb-6 font-semibold">Contact</h4>
              <ul className="space-y-3">
                <li>
                  <a href="mailto:michiele.tornabene@atmahealthcareconsulting.com" className="text-white hover:text-[#C9A961] transition-colors duration-300 text-xs whitespace-nowrap">
                    michiele.tornabene@atmahealthcareconsulting.com
                  </a>
                </li>
                <li className="text-gray-400 leading-relaxed">
                  2570 Route de Loqui<br />13290 Aix-en-Provence
                </li>
              </ul>
            </div>

            <div className="pl-8">
              <h4 className="text-sm uppercase text-gray-400 mb-6 font-semibold">À Propos</h4>
              <ul className="space-y-3">
                <li>
                  <Link to="/qui-sommes-nous" className="text-white hover:text-[#C9A961] transition-colors duration-300">
                    Qui sommes-nous ?
                  </Link>
                </li>
                <li>
                  <Link to="/nos-valeurs" className="text-white hover:text-[#C9A961] transition-colors duration-300">
                    Nos Valeurs
                  </Link>
                </li>
                <li>
                  <Link to="/articles" className="text-white hover:text-[#C9A961] transition-colors duration-300">
                    Articles
                  </Link>
                </li>
              </ul>
            </div>
          </div>

          <div className="border-t border-gray-800 pt-8 flex items-center justify-between">
            <p className="text-gray-400 text-sm">
              © 2025 ATMA Consulting. Tous droits réservés.
            </p>
            <div className="flex gap-8">
              <Link to="/mentions-legales" className="text-gray-400 hover:text-[#C9A961] transition-colors duration-300 text-sm">
                Mentions Légales
              </Link>
              <Link to="/confidentialite" className="text-gray-400 hover:text-[#C9A961] transition-colors duration-300 text-sm">
                Confidentialité
              </Link>
              <a href="https://readdy.ai/?ref=logo" target="_blank" rel="noopener noreferrer" className="text-gray-400 hover:text-[#C9A961] transition-colors duration-300 text-sm">
                Powered by Readdy
              </a>
            </div>
          </div>
        </div>
      </footer>
    </div>
  );
}
